/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SemanticDatasetMentionDetailsFragment = {
  readonly __typename: "SemanticDataset";
  readonly id: c.SemanticDatasetId;
  readonly name: c.SemanticDatasetName;
  readonly title: string | null;
  readonly description: string | null;
  readonly status: {
    readonly __typename: "Status";
    readonly id: c.StatusId;
  } | null;
  readonly semanticProject: {
    readonly __typename: "SemanticProject";
    readonly id: c.SemanticProjectId;
    readonly name: string;
  };
};

export type SemanticViewMentionDetailsFragment = {
  readonly __typename: "SemanticView";
  readonly id: c.SemanticViewId;
  readonly name: c.SemanticViewName;
  readonly title: string | null;
  readonly description: string | null;
  readonly status: {
    readonly __typename: "Status";
    readonly id: c.StatusId;
  } | null;
  readonly semanticProject: {
    readonly __typename: "SemanticProject";
    readonly id: c.SemanticProjectId;
    readonly name: string;
  };
};

export type SemanticDatasetMentionDetailsQueryVariables = Types.Exact<{
  semanticDatasetName: Types.Scalars["SemanticDatasetName"]["input"];
  semanticProjectId: Types.Scalars["SemanticProjectId"]["input"];
  semanticProjectVersionString: Types.Scalars["SemanticProjectVersionString"]["input"];
}>;

export type SemanticDatasetMentionDetailsQuery = {
  readonly __typename: "Query";
  readonly semanticDatasetByName: {
    readonly __typename: "SemanticDataset";
    readonly id: c.SemanticDatasetId;
    readonly name: c.SemanticDatasetName;
    readonly title: string | null;
    readonly description: string | null;
    readonly status: {
      readonly __typename: "Status";
      readonly id: c.StatusId;
    } | null;
    readonly semanticProject: {
      readonly __typename: "SemanticProject";
      readonly id: c.SemanticProjectId;
      readonly name: string;
    };
  };
};

export type SemanticViewMentionDetailsQueryVariables = Types.Exact<{
  semanticViewName: Types.Scalars["SemanticViewName"]["input"];
  semanticProjectId: Types.Scalars["SemanticProjectId"]["input"];
  semanticProjectVersionString: Types.Scalars["SemanticProjectVersionString"]["input"];
}>;

export type SemanticViewMentionDetailsQuery = {
  readonly __typename: "Query";
  readonly semanticViewByName: {
    readonly __typename: "SemanticView";
    readonly id: c.SemanticViewId;
    readonly name: c.SemanticViewName;
    readonly title: string | null;
    readonly description: string | null;
    readonly status: {
      readonly __typename: "Status";
      readonly id: c.StatusId;
    } | null;
    readonly semanticProject: {
      readonly __typename: "SemanticProject";
      readonly id: c.SemanticProjectId;
      readonly name: string;
    };
  };
};

export const SemanticDatasetMentionDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment SemanticDatasetMentionDetailsFragment on SemanticDataset {
    id
    name
    title
    description
    status {
      id
    }
    semanticProject {
      id
      name
    }
  }
`;
export const SemanticViewMentionDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment SemanticViewMentionDetailsFragment on SemanticView {
    id
    name
    title
    description
    status {
      id
    }
    semanticProject {
      id
      name
    }
  }
`;
export const SemanticDatasetMentionDetailsQueryDocument = /*#__PURE__*/ gql`
  query SemanticDatasetMentionDetailsQuery(
    $semanticDatasetName: SemanticDatasetName!
    $semanticProjectId: SemanticProjectId!
    $semanticProjectVersionString: SemanticProjectVersionString!
  ) {
    semanticDatasetByName(
      semanticDatasetName: $semanticDatasetName
      semanticProjectId: $semanticProjectId
      semanticProjectVersionString: $semanticProjectVersionString
    ) {
      ...SemanticDatasetMentionDetailsFragment
    }
  }
  ${SemanticDatasetMentionDetailsFragmentDoc}
`;

/**
 * __useSemanticDatasetMentionDetailsQuery__
 *
 * To run a query within a React component, call `useSemanticDatasetMentionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSemanticDatasetMentionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSemanticDatasetMentionDetailsQuery({
 *   variables: {
 *      semanticDatasetName: // value for 'semanticDatasetName'
 *      semanticProjectId: // value for 'semanticProjectId'
 *      semanticProjectVersionString: // value for 'semanticProjectVersionString'
 *   },
 * });
 */
export function useSemanticDatasetMentionDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SemanticDatasetMentionDetailsQuery,
    SemanticDatasetMentionDetailsQueryVariables
  > &
    (
      | {
          variables: SemanticDatasetMentionDetailsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SemanticDatasetMentionDetailsQuery,
    SemanticDatasetMentionDetailsQueryVariables
  >(SemanticDatasetMentionDetailsQueryDocument, options);
}
export function useSemanticDatasetMentionDetailsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SemanticDatasetMentionDetailsQuery,
    SemanticDatasetMentionDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SemanticDatasetMentionDetailsQuery,
    SemanticDatasetMentionDetailsQueryVariables
  >(SemanticDatasetMentionDetailsQueryDocument, options);
}
export function useSemanticDatasetMentionDetailsQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SemanticDatasetMentionDetailsQuery,
    SemanticDatasetMentionDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SemanticDatasetMentionDetailsQuery,
    SemanticDatasetMentionDetailsQueryVariables
  >(SemanticDatasetMentionDetailsQueryDocument, options);
}
export type SemanticDatasetMentionDetailsQueryHookResult = ReturnType<
  typeof useSemanticDatasetMentionDetailsQuery
>;
export type SemanticDatasetMentionDetailsQueryLazyQueryHookResult = ReturnType<
  typeof useSemanticDatasetMentionDetailsQueryLazyQuery
>;
export type SemanticDatasetMentionDetailsQuerySuspenseQueryHookResult =
  ReturnType<typeof useSemanticDatasetMentionDetailsQuerySuspenseQuery>;
export type SemanticDatasetMentionDetailsQueryQueryResult = Apollo.QueryResult<
  SemanticDatasetMentionDetailsQuery,
  SemanticDatasetMentionDetailsQueryVariables
>;
export const SemanticViewMentionDetailsQueryDocument = /*#__PURE__*/ gql`
  query SemanticViewMentionDetailsQuery(
    $semanticViewName: SemanticViewName!
    $semanticProjectId: SemanticProjectId!
    $semanticProjectVersionString: SemanticProjectVersionString!
  ) {
    semanticViewByName(
      semanticViewName: $semanticViewName
      semanticProjectId: $semanticProjectId
      semanticProjectVersionString: $semanticProjectVersionString
    ) {
      ...SemanticViewMentionDetailsFragment
    }
  }
  ${SemanticViewMentionDetailsFragmentDoc}
`;

/**
 * __useSemanticViewMentionDetailsQuery__
 *
 * To run a query within a React component, call `useSemanticViewMentionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSemanticViewMentionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSemanticViewMentionDetailsQuery({
 *   variables: {
 *      semanticViewName: // value for 'semanticViewName'
 *      semanticProjectId: // value for 'semanticProjectId'
 *      semanticProjectVersionString: // value for 'semanticProjectVersionString'
 *   },
 * });
 */
export function useSemanticViewMentionDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SemanticViewMentionDetailsQuery,
    SemanticViewMentionDetailsQueryVariables
  > &
    (
      | { variables: SemanticViewMentionDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SemanticViewMentionDetailsQuery,
    SemanticViewMentionDetailsQueryVariables
  >(SemanticViewMentionDetailsQueryDocument, options);
}
export function useSemanticViewMentionDetailsQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SemanticViewMentionDetailsQuery,
    SemanticViewMentionDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SemanticViewMentionDetailsQuery,
    SemanticViewMentionDetailsQueryVariables
  >(SemanticViewMentionDetailsQueryDocument, options);
}
export function useSemanticViewMentionDetailsQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SemanticViewMentionDetailsQuery,
    SemanticViewMentionDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SemanticViewMentionDetailsQuery,
    SemanticViewMentionDetailsQueryVariables
  >(SemanticViewMentionDetailsQueryDocument, options);
}
export type SemanticViewMentionDetailsQueryHookResult = ReturnType<
  typeof useSemanticViewMentionDetailsQuery
>;
export type SemanticViewMentionDetailsQueryLazyQueryHookResult = ReturnType<
  typeof useSemanticViewMentionDetailsQueryLazyQuery
>;
export type SemanticViewMentionDetailsQuerySuspenseQueryHookResult = ReturnType<
  typeof useSemanticViewMentionDetailsQuerySuspenseQuery
>;
export type SemanticViewMentionDetailsQueryQueryResult = Apollo.QueryResult<
  SemanticViewMentionDetailsQuery,
  SemanticViewMentionDetailsQueryVariables
>;
